import { Box, Paper } from "@mui/material";
import loginBg from "../assets/images/login_bg.png";
import logoGreen from "../assets/images/logo_smaart_green.png";
import LoginForm from "../components/login/login.component";

const LoginPage = () => {
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundImage: `url(${loginBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          width: "512px",
          height: "388px",
          backgroundColor: "#ffffff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          p: 4,
        }}
      >
        <Box
          component="img"
          src={logoGreen}
          alt="Smaart Logo"
          sx={{
            width: "177.69px",
            height: "30.6px",
            mb: 4,
          }}
        />
        <LoginForm />
      </Paper>
    </Box>
  );
};

export default LoginPage;
